import { updateWidgetMetaPropAndEval } from "actions/metaActions";
import { selectWidgetInitAction } from "actions/widgetSelectionActions";
import { all, put, select } from "redux-saga/effects";
import {
  getWidgetByName,
  getWidgetIdsByTypes,
  getWidgetsMeta,
} from "sagas/selectors";
import { SelectionRequestType } from "sagas/WidgetSelectUtils";
import AppsmithConsole from "utils/AppsmithConsole";
import { flatten } from "lodash";
import type { FlattenedWidgetProps } from "WidgetProvider/constants";
import type {
  TCloseDrawerDescription,
  TOpenDrawerDescription,
} from "workers/Evaluation/fns/drawerFns";

export function* openDrawerSaga(action: TOpenDrawerDescription) {
  const { name: drawerName } = action.payload;

  if (drawerName) {
    const drawer: FlattenedWidgetProps = yield select(
      getWidgetByName,
      drawerName,
    );
    if (drawer) {
      yield put(
        updateWidgetMetaPropAndEval(drawer.widgetId, "isVisible", true),
      );
      AppsmithConsole.info({
        text: `openDrawer('${drawerName}') was triggered`,
      });
    }
  }
}

export function* closeDrawerSaga(action: TCloseDrawerDescription) {
  const { name: drawerName } = action.payload;

  if (drawerName) {
    // 关闭指定名称的抽屉
    const drawer: FlattenedWidgetProps = yield select(
      getWidgetByName,
      drawerName,
    );
    if (drawer) {
      yield put(
        updateWidgetMetaPropAndEval(drawer.widgetId, "isVisible", false),
      );
      yield put(selectWidgetInitAction(SelectionRequestType.Empty));
      AppsmithConsole.info({
        text: `closeDrawer('${drawerName}') was triggered`,
      });
    }
  } else {
    // 如果没有指定名称，关闭所有打开的抽屉
    try {
      let widgetIds: string[] = [];

      // 获取所有组件的元数据
      const metaProps: Record<string, any> = yield select(getWidgetsMeta);

      // 获取所有抽屉组件的widgetId
      const drawerWidgetIds: string[] = yield select(getWidgetIdsByTypes, [
        "ANTD_GLOBAL_DRAWER_WIDGET",
      ]);

      // 遍历所有抽屉组件，找出已打开的
      drawerWidgetIds.forEach((widgetId: string) => {
        // 检查抽屉是否已打开
        if (metaProps[widgetId] && metaProps[widgetId].isVisible) {
          // 添加到需要关闭的列表中
          widgetIds.push(widgetId);
        }
      });

      // 如果有需要关闭的抽屉，则批量关闭
      if (widgetIds && widgetIds.length > 0) {
        yield all(
          flatten(
            widgetIds.map((widgetId: string) => [
              put(updateWidgetMetaPropAndEval(widgetId, "isVisible", false)),
            ]),
          ),
        );

        // 取消选中所有组件
        yield put(selectWidgetInitAction(SelectionRequestType.Empty));

        AppsmithConsole.info({
          text: `Closed ${widgetIds.length} open drawer(s)`,
        });
      }
    } catch (error) {
      AppsmithConsole.error({
        text: `Error closing drawers: ${error}`,
      });
    }
  }
}
